const locale = {
  GUEST_DISPLAYNAME: 'Invitado',
  LOCATION: '',
  DEFAULT_LOCATION: '',
};

export default locale;
